import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

/* ------------------ SmoothLightbox (pure React) ------------------ */
function SmoothLightbox({ items, index, onClose, onPrev, onNext }) {
  // Lock body scroll while open
  useEffect(() => {
    if (index >= 0) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => (document.body.style.overflow = prev);
    }
  }, [index]);

  // Keyboard nav
  useEffect(() => {
    if (index < 0) return;
    const handler = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.key === "ArrowLeft") onPrev();
      else if (e.key === "ArrowRight") onNext();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [index, onClose, onPrev, onNext]);

  if (index < 0) return null;
  const item = items[index];

  return (
    <div className="slb-overlay" role="dialog" aria-modal="true" aria-label="Image preview">
      <div className="slb-backdrop" onClick={onClose} />

      <div className="slb-inner" aria-hidden={false}>
        <button className="slb-close" onClick={onClose} aria-label="Close">✕</button>

        <button className="slb-nav slb-prev" onClick={onPrev} aria-label="Previous">‹</button>

        <figure className="slb-media">
          <img src={item.src} alt={item.alt || item.caption || `Image ${index + 1}`} className="slb-img" />
          {item.caption && <figcaption className="slb-caption">{item.caption}</figcaption>}
          <div className="slb-counter">{index + 1} / {items.length}</div>
        </figure>

        <button className="slb-nav slb-next" onClick={onNext} aria-label="Next">›</button>
      </div>
    </div>
  );
}

/* ------------------ Video modal (Bootstrap markup kept) ------------------ */
const ImageModal = () => {
  useEffect(() => {
    const modalElement = document.getElementById("imageModal");

    if (modalElement) {
      modalElement.addEventListener("hide.bs.modal", () => {
        const iframe = modalElement.querySelector("iframe");
        if (iframe) {
          iframe.src = ""; // Clear the iframe source to stop the video
        }
      });

      modalElement.addEventListener("show.bs.modal", () => {
        const iframe = modalElement.querySelector("iframe");
        if (iframe) {
          iframe.src = "https://www.youtube.com/embed/eK4n1KWY61I?si=Ffme_r1equSxwySL";
        }
      });
    }

    return () => {
      if (modalElement) {
        modalElement.removeEventListener("hide.bs.modal", () => {});
        modalElement.removeEventListener("show.bs.modal", () => {});
      }
    };
  }, []);

  return (
    <div
      className="modal fade snapshotsModal"
      id="imageModal"
      tabIndex="-1"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body text-center">
            <iframe
              width="100%"
              height="425"
              src="https://www.youtube.com/embed/ZiT5EZBVxWM?autoplay=0&rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};


export default function Brandingandgraphicdesign() {
  const gallery = useMemo(
    () =>
      Array.from({ length: 83 }, (_, i) => {
        const num = i + 1;
        return {
          src: require(`../assets/img/work/signage/signage-indoor-img${num}.jpg`),
          caption: "Signage Indoor",
          alt: `Brand ${num}`,
        };
      }),
    []
  );

  const [activeIndex, setActiveIndex] = useState(-1);

  const openAt = useCallback((i) => setActiveIndex(i), []);
  const closeLightbox = useCallback(() => setActiveIndex(-1), []);
  const prev = useCallback(() => setActiveIndex((prev) => (prev <= 0 ? gallery.length - 1 : prev - 1)), [gallery.length]);
  const next = useCallback(() => setActiveIndex((prev) => (prev >= gallery.length - 1 ? 0 : prev + 1)), [gallery.length]);

  return (
    <>
    <section className="innerPages">
      <Container>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box1">
                <h1>Elixir & AR <span>Signage Indoor</span></h1>
                <h4>Eye-Catching Custom Indoor Signage for Businesses</h4>
              </div>
            </Col>
            <Col lg={6}>
              <div className="innerPages-box2">
                <div className="servicesInner-content">                  
                  <Row>
                    <h4>Transform with <span>Stunning Indoor Signage</span></h4>
                    <Col md={12}>
                      <p>Enhance your space with vibrant, customizable indoor signage that captures attention and communicates your brand with clarity. Ideal for retail stores, offices, events, and more, our signage is durable, stylish, and designed to leave a lasting impression.</p>   
                      <p>Elevate your interiors with premium indoor signage crafted to reflect your brand’s identity, engage your audience, and create memorable experiences in any environment.</p>                  
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={3}> 
              <div className="innerPages-box3">      
                <div className="logoPart">
                  <h5><span>"</span>A Complete Communication Solutions<span>"</span></h5>
                  <hr />
                  <p><span>Mail:</span> <a href="mailto:anand@elixirworldwide.com">anand@elixirworldwide.com</a></p>
                  <p><span>Mobile:</span> <a href="tel:+966552301809">+966 55 230 1809</a></p>         
                </div>
              </div>     
            </Col>
          </Row>
        </div>
        <div className="">
          <Row data-aos="fade-up" data-aos-duration="3000">
            <Col lg={3}>
              <div className="innerPages-box4">  
                <ul className="recentproLinks">
                  <hr />
                  <li>Digital Displays</li>
                  <li>LED Signs</li>
                  <li>Channel Letters</li>
                  <li>Wall Graphics</li>
                  <li>Floor Decals</li>
                  <li>Menu Boards</li>
                  <li>Acrylic Signs</li>
                  <li>Retail Signage</li>
                  <li>Hospitality Signs</li>
                  <li>Industrial Safety Signs</li>
                  <li>Corporate Branding</li>
                  <li>Real Estate Signs</li>
                </ul>
              </div>
            </Col>
            <Col lg={9}>            
            <div className="aboutPages-box5">     
              <div className="servicesInner-content">                
                <Row>
                  <h4>Recent <span>Works</span></h4>
                  {gallery.map((g, i) => (
                    <Col key={i} lg={4} md={6} data-aos="fade-up" data-aos-duration="3000" className="mb-2">
                      <div className="latestWork-box" role="button" onClick={() => openAt(i)}>
                        <img src={g.src} className="img-fluid" alt={g.alt} />
                        <div className="overlay">
                          <div className="text">
                            <h4>BEST</h4>
                            <p>{g.caption}</p>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
            </Col>
          </Row>
        </div>
      </Container>            
    </section>

    {/* Smooth/react lightbox */}
    <SmoothLightbox items={gallery} index={activeIndex} onClose={closeLightbox} onPrev={prev} onNext={next} />
    </>
  );
}
